import useId from '@mui/utils/useId';
import { clsx } from 'clsx';
import { FC, MouseEventHandler } from 'react';
import { Rating } from 'atoms/Rating';
import { RatingWithTooltip } from 'atoms/Rating/RatingWithTooltip';
import { DefaultRatingProps, RatingInfoProps } from 'atoms/Rating/types';
import { CTA } from 'atoms/Typography/Typography';
import { useRouter } from 'modules/next/hooks';
import styles from './ReviewsRating.module.css';

type IReviewsRating = DefaultRatingProps & Partial<RatingInfoProps>;

export const ReviewsRating: FC<IReviewsRating> = ({
  value = 0,
  count = 0,
  ranks = [],
  url = '',
  size,
  color,
  className,
  onClick,
}) => {
  const hasTooltip = !!ranks.length;
  const anchoredUrl = useId(`${url}#reviews`);

  const { push } = useRouter();

  const handleClick: MouseEventHandler = (e) => {
    // needed to prevent wrapped link behavior
    e.preventDefault();

    if (url && count) {
      push(anchoredUrl || url);
    }
  };

  return (
    <div
      onClick={onClick}
      className={clsx(styles.root, size && styles[size], className)}
    >
      {hasTooltip ? (
        <RatingWithTooltip
          value={value}
          count={count}
          color={color}
          size={size}
          ranks={ranks}
          className={className}
          url={anchoredUrl || url}
        />
      ) : (
        <Rating size={size} value={value} color={color} />
      )}

      <CTA
        type="md"
        className={clsx(
          styles.link,
          !!count && styles.pointer,
          color && styles[color],
          size && styles[size],
        )}
        onClick={handleClick}
      >
        ({count})
      </CTA>
    </div>
  );
};
